import has from 'lodash/has'
import Loader from '~/libs/queue/components/frontend/loader'

export default {
  components: {
    Loader,
  },
  data () {
    return {
      queueId: null,
    }
  },
  methods: {
    /**
     * Create a safe queue ID, based on component internal ID.
     * @return {string}
     */
    safeQueueId () {
      if (this.queueId === null) {
        this.queueId = `__queue__${this._uid}`
      }

      return this.queueId
    },
  },
  created () {
    if (has(this, 'queue') && typeof this.queue === 'function') {
      this.queue()
    }
  },
}
